/* ============
 * excise Transformer
 * ============
 */

import Transformer from './transformer';

export default class ExciseDutyTransformer extends Transformer {

  static fetch(excise) {
    return {
      id: excise.id,
      title: excise.title,
      type: excise.type,
      description: excise.description,
      group_id: excise.group_id,
      unit_type: excise.unit_type,
      rate: excise.rate,
      code: excise.code,
      codeId: excise.code_id,
    };
  }

  static send(excise) {
    return {
      id: excise.id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/exciseGroup.js